import InlineSelect from '../InlineSelect';
import SearchBar from '../Search';
import SideMenuCatalog from '../SideMenuCatalog';
import EquipmentAdvancedFilter from './components/EquipmentAdvancedFilter';
import ModuleAdvancedFilter from './components/ModuleAdvancedFilter';
import { FilterOptionsEnum, useIdCatalogSearch } from './context';

import { Container, ControlWrapper, FilterContainer, FilterHeader, ResultContainer } from './styles';

const filterOptions = [
  {
    id: 'equipment',
    label: 'Equipment',
  },
  {
    id: 'module',
    label: 'Module',
  },
];

const SideMenuSearchLane = ({ isCollapsed }) => {
  const { filterOptionId, setFilterOptionId, updateSearchFilterField, addCatalogItem, addSecondCatalogItem } =
    useIdCatalogSearch();

  const AdvancedFilterComponent =
    filterOptionId === FilterOptionsEnum.Module ? ModuleAdvancedFilter : EquipmentAdvancedFilter;

  return (
    <Container>
      <FilterContainer>
        <FilterHeader>Catalog Search</FilterHeader>
        <ControlWrapper>
          <SearchBar
            value={undefined}
            onInputChange={(event) => updateSearchFilterField('searchInput', event.target.value)}
          />
        </ControlWrapper>
        <AdvancedFilterComponent />
      </FilterContainer>
      <ResultContainer>
        <SideMenuCatalog
          isAddCardEnabled={!isCollapsed}
          onCatalogCardClick={(item) => addCatalogItem(item.tagId, item.fpso)}
          onCatalogCardCompareClick={(item) => addSecondCatalogItem(item.tagId, item.fpso)}
        />
      </ResultContainer>
    </Container>
  );
};

export default SideMenuSearchLane;
